import styles from "../../../styles/beneficios/FoldersList.module.scss";

import { useNavigate } from "react-router-dom";

import classNames from "classnames/bind";
import { Icon } from "../../components/core/Icon";
const css = classNames.bind(styles);

export default function FoldersList({ folders = [] }) {
  const navigate = useNavigate();

  return (
    <div className={styles.foldersList}>
      <p className={styles.label}>Suas pastas ({folders.length})</p>

      <div className={styles.folders}>
        <div
          className={css({
            folder: true,
            archived: true,
          })}
          onClick={() => navigate("/beneficios/arquivados")}
        >
          <i className="fal fa-archive" />
          <p>Arquivados</p>
        </div>
        {folders.map((folder) => (
          <div
            className={styles.folder}
            onClick={() => navigate(`/beneficios/pasta/${folder.id}`)}
          >
            <i className="fas fa-folder" />
            <p>{folder.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
